import { Autocomplete, FormControl, Grid } from '@mui/material';
import { StyledFormLabel, StyledTextField } from 'components/atoms';
import {
  AutocompleteFieldProps,
  withGridItemCSS,
  withWrapperCSS,
} from 'components/organisms/forms/form-builder/types';
import { noop } from 'lodash';
import React, { FC, useState } from 'react';

export const AutocompleteField: FC<
  AutocompleteFieldProps & withGridItemCSS & withWrapperCSS
> = ({
  error,
  fieldKey,
  gridItemCss,
  label = '',
  labelCss,
  options,
  onChange = noop,
  placeholder = '',
  required = false,
  wrapperCss,
  xs = 12,
}) => {
  const [hasError, setHasError] = useState(error ? error : false);

  const handleInputChange = (newValue: string | null) => {
    if (required && !newValue) setHasError(true);
    else setHasError(false);
    const value = options.find((opt) => opt.description === newValue);
    onChange(value?.name || 0, fieldKey);
  };

  return (
    <Grid item xs={xs} style={gridItemCss}>
      <FormControl
        error={!!hasError}
        required={required}
        style={{ width: '100%', ...wrapperCss }}
      >
        <StyledFormLabel error={!!hasError} style={labelCss}>
          {label} {required ? '*' : null}
        </StyledFormLabel>
        <Autocomplete
          freeSolo
          disablePortal
          onInputChange={(_event: any, newInputValue) => {
            handleInputChange(newInputValue);
          }}
          options={options.map((opt) => opt.description)}
          renderInput={(params) => (
            <StyledTextField
              variant="outlined"
              {...params}
              placeholder={placeholder}
              error={!!hasError}
            />
          )}
        />
      </FormControl>
    </Grid>
  );
};
